/* =============================================================
   arije — Page collection
   - suppression du selecteur de vue grille / carrousel
   - repli de la description de collection quand elle est longue
   - apparition en cascade des cartes
   ============================================================= */
(function () {
  'use strict';
  if (window.__arijeCollection) return;
  window.__arijeCollection = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------
     1. Selecteur de vue

     Balisage reel, dans snippets/facets.liquid :
       <div class="modes">
         <a class="modes-mode mode-slider" data-role="mode-switcher">Slider</a>
         <a class="modes-mode mode-grid"   data-role="mode-grid">Grid</a>
       </div>

     Ce filet de securite peut disparaitre une fois le bloc retire
     du snippet.
     --------------------------------------------------------- */
  function removeViewSwitcher() {
    var modes = document.querySelectorAll('.modes, [data-role="mode-switcher"], [data-role="mode-grid"]');
    Array.prototype.forEach.call(modes, function (el) {
      var box = el.classList.contains('modes') ? el : el.closest('.modes') || el;
      if (box && box.parentNode) box.parentNode.removeChild(box);
    });

    var slider = document.querySelector('.product-slider-content');
    if (slider && slider.parentNode) slider.parentNode.removeChild(slider);

    var grid = document.querySelector('.product-grid-content');
    if (grid) grid.classList.add('active');
  }

  /* ---------------------------------------------------------
     2. Description de collection trop longue
     --------------------------------------------------------- */
  function clampDescription() {
    var desc = document.querySelector('.collection-hero__description');
    if (!desc || desc.hasAttribute('data-cg-clamp')) return;
    desc.setAttribute('data-cg-clamp', '');

    if (desc.scrollHeight <= 300) return;
    desc.classList.add('is-clamped');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cg-more';
    btn.textContent = 'Lire la suite';
    btn.setAttribute('aria-expanded', 'false');
    desc.parentNode.insertBefore(btn, desc.nextSibling);

    btn.addEventListener('click', function () {
      var open = desc.classList.toggle('is-clamped') === false;
      btn.textContent = open ? 'Réduire' : 'Lire la suite';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------------------------------------------------------
     3. Apparition en cascade
     --------------------------------------------------------- */
  var io = null;
  function observer() {
    if (io) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    return io;
  }

  function reveal(root) {
    var els = (root || document).querySelectorAll(
      '.product-grid-content .product-grid-product-card:not([data-cg])'
    );
    if (!els.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) {
        el.classList.add('is-in');
        el.setAttribute('data-cg', '');
      });
      return;
    }

    Array.prototype.forEach.call(els, function (el, i) {
      el.setAttribute('data-cg', '');
      el.style.setProperty('--cg-d', (i % 4) * 80 + 'ms');
      observer().observe(el);
    });
  }

  function watch() {
    var host = document.querySelector('.product-grid-container');
    if (!host || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      reveal(document);
      removeViewSwitcher();
    }).observe(host, { childList: true, subtree: true });
  }

  function boot() {
    if (!document.body.classList.contains('template-collection')) return;
    removeViewSwitcher();
    clampDescription();
    reveal(document);
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', removeViewSwitcher);
  document.addEventListener('shopify:section:load', function () { boot(); });
})();
